<template>
  <button :class="{ [`button--${variant}`]: variant }"
          class="button">
    <slot/>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    variant: {
      type: String,
      required: false,
      default: 'green',
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  border: 0;
  font-weight: 100;
  font-size: 0.9rem;
  border-radius: 2px;
  padding: 7px 13px;
  font-weight: 500;
  width: 100%;
  background-color: #28522d;
  color: white;
  margin-left: 10px;
  cursor: pointer;

  &--green {
    background-color: #28522d;
    color: white;

    &:hover {
      background-color: #477b4d;
    }
  }

  &--grey {
    background-color: #d4d4d4;
    color: #000;

    &:hover {
      background-color: #bbbbbb;
    }
  }

  &:first-of-type {
    margin-left: 0;
  }
}
</style>
